import logoNoronCar from '../Images/logo.png'
import config from "../config.json";
import loginLogo from '../Images/logoWeb.png'
import React, { useContext, useEffect, useState, useRef } from "react";
import AddImage from '../Images/AddImage.png'
import { Link } from 'react-router-dom';
import http from "../Services/httpService";
import services from "../Services/services";
import { toast } from "react-toastify";
import { useNavigate } from 'react-router-dom';


export default function InsuranceShow() {

    useEffect(() => {

        loadInsurance();
    }, []);

    const [isLoadingInsurance, setIsLoadingInsurance] = useState(false)
    const [listInsurance, setListInsurance] = useState([])
    const loadInsurance = async () => {
        setIsLoadingInsurance(true);
        setListInsurance([]); setListInsuranceDetail([]);
        await services.InsuranceList()
            .then(async ({ data }) => {
                setIsLoadingInsurance(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                setListInsurance(data.payload)
                if (data.payload.length && data.payload.length ==1)
                    await doInsuranceDetail(null, data.payload[0].id)
            })
            .catch(err => {
                setIsLoadingInsurance(false);
            });
    }

    const [listInsuranceDetail, setListInsuranceDetail] = useState([])
    const [isLoadingInsuranceDetail, setIsLoadingInsuranceDetail] = useState(false)
    const doInsuranceDetail = async (e, id) => {
        if (e)
            e.preventDefault();
        setListInsuranceDetail([])
        setIsLoadingInsuranceDetail(true);
        await services.InsuranceGetDetail(id)
            .then(async ({ data }) => {
                setIsLoadingInsuranceDetail(false);
                if (data.errorCode != 0) {
                    toast.error(data.message, { theme: "colored" });
                    return
                }
                setListInsuranceDetail(data.payload)
            })
            .catch(err => {
                setIsLoadingInsuranceDetail(false);
            });
    }

    return (
        <>

            {isLoadingInsurance &&
                <div className="spinner-border spinner-border-sm" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            }

            <table className="table   table-striped-columns table-striped table-hover border table table-border2  ">
                <thead>
                    <tr>
                        <th >
                            تاریخ
                        </th>
                        <th >
                            اصلی/تبعه
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {listInsurance.map((x, i) => (
                        <tr key={i + "r"}>
                            <td>
                                {x.dtFa}
                            </td>
                            <td>
                                {listInsurance.length > 1 &&
                                    <button
                                        disabled={isLoadingInsuranceDetail}
                                        onClick={e => { doInsuranceDetail(e, x.id) }}
                                        className='btn btn-info'>
                                        لیست تبعه
                                    </button>
                                }
                            </td>
                        </tr>
                    ))}
                </tbody>
                <tfoot>
                    <tr>
                        <td  >

                        </td>
                    </tr>
                </tfoot>
            </table>

            {listInsuranceDetail.length > 0 &&
                <table className="table   table-striped-columns table-striped table-hover border table table-border2  ">
                    <thead>
                        <tr>
                            <th>
                                نام و نام خانوادگی
                            </th>
                            <th>
                                نام پدر
                            </th>
                            <th>
                                شماره شناسنامه
                            </th>
                            <th>
                                کد ملی
                            </th>
                            <th>
                                محل تولد
                            </th>
                            <th>
                                نسبت
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {listInsuranceDetail.map((x, i) => (
                            <tr key={i + "rr"}>
                                <td>
                                    {`${x.name} ${x.family}`}
                                </td>
                                <td>
                                    {x.fatherName}
                                </td>
                                <td>
                                    {x.code}
                                </td>
                                <td>
                                    {x.codeMeli}
                                </td>
                                <td>
                                    {x.placeBirthName}
                                </td>
                                <td>
                                    {x.nesbatName}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td  >

                            </td>
                        </tr>
                    </tfoot>
                </table>
            }

        </>

    );

}
